module.exports = __webpack_public_path__ + "static/docker-689c02aa070ae2141cbdddcf559e1f1f.png";